import { useEffect, useState } from "react";
import { PageHeader } from "@/components/PageHeader";
import { LoadingState, ErrorState } from "@/components/LoadingError";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { apiFetch } from "@/utils/api";

export function AdminMailPage() {
  const [mailFrom, setMailFrom] = useState("");
  const [mailEnabled, setMailEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    apiFetch<{ mailFrom: string; mailEnabled: boolean }>("/admin/mail-settings")
      .then((d) => {
        setMailFrom(d.mailFrom ?? "");
        setMailEnabled(d.mailEnabled);
      })
      .catch((e) => setError(e instanceof Error ? e.message : "Failed to load"))
      .finally(() => setLoading(false));
  }, []);

  const save = async () => {
    setSaved(false);
    await apiFetch("/admin/mail-settings", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ mailFrom, mailEnabled }),
    });
    setSaved(true);
  };

  if (loading) return <LoadingState />;
  if (error) return <ErrorState message={error} />;

  return (
    <div className="space-y-4">
      <PageHeader
        title="Email Settings"
        subtitle="Configure notification settings. Email delivery requires Cloudflare Email Workers integration."
      />
      <div className="bg-white rounded-lg shadow p-6 space-y-4 max-w-lg">
        <div className="flex items-center justify-between">
          <Label htmlFor="mailEnabled">Enable Email Notifications</Label>
          <Switch id="mailEnabled" checked={mailEnabled} onCheckedChange={setMailEnabled} />
        </div>
        <div className="space-y-1.5">
          <Label>From Address</Label>
          <Input
            type="email"
            value={mailFrom}
            onChange={(e) => setMailFrom(e.target.value)}
            placeholder="notifications@yourdomain.com"
          />
        </div>
        <Button onClick={save} className="bg-[#1e3a4f] hover:bg-[#163041]">Save</Button>
        {saved && <p className="text-sm text-green-700">Settings saved.</p>}
      </div>
    </div>
  );
}
